define('services/navigation',['plugins/router','services/logger','services/appsecurity'], function(router,logger,appsecurity){

    var navigation = {
        loginSuccessful: loginSuccessful,
        loginSuccessfulUser: loginSuccessfulUser,
        loginSuccessfulAdmin: loginSuccessfulAdmin,
        loginSuccessfulSurvey: loginSuccessfulSurvey,
        unauthorized: unauthorized,
        childPageName: ko.observable("ClientDetails"),
        setChildPageName: setChildPageName,
        logger: logger,
        appsecurity: appsecurity
    };

    return navigation;



    function setChildPageName(pageName) {
      
        try{
            navigation.childPageName(pageName);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: setChildPageName() method in navigation.js';
            logger.logMessage(msg);
        }
    }

    function loginSuccessfulAdmin() {
       
        try{
            router.navigate("Landing", true);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: loginSuccessfulAdmin() method in navigation.js';
            logger.logMessage(msg);
        }
    }

    function loginSuccessfulUser() {
        
        try{
            router.navigate("Landing", true);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: loginSuccessfulUser() method in navigation.js';
            logger.logMessage(msg);
        }
    }

    function loginSuccessfulSurvey() {
        
        try{
            router.navigate("Landing", true);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: loginSuccessfulSurvey() method in navigation.js';
            logger.logMessage(msg);
        }
    }
    function loginSuccessful() {
        
        try{
            router.navigate("Landing",true);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: loginSuccessful() method in navigation.js';
            logger.logMessage(msg);
        }
    }

    function unauthorized() {
        
        try {
            for (var i = 0; i < $('.modal').length; i++) {
                if ($($('.modal').get(i)).attr("aria-hidden") == 'false')
                    $($('.modal').get(i)).modal('hide');
            }
            $('.modal-backdrop').remove();
            navigation.appsecurity.DestroyBrowserCookie();
            var ReturnUrl = encodeURIComponent(window.location.hash.replace('#', ''));
            router.navigate("/?returnUrl=" + ReturnUrl, true);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: unauthorized() method in navigation.js';
            logger.logMessage(msg);
        }
    };

});

